export const SET_DIMENSIONS_EXPANDED_CAM = 'SET_DIMENSIONS_EXPANDED_CAM';

export const SHOW_HIDE_DEACTIVATE_COMPANY_SUCCESS_MODAL = 'SHOW_HIDE_DEACTIVATE_COMPANY_SUCCESS_MODAL';
